export const calendarRoutes = {
  'api.calendar.holiday-list': 'home/holiday-list',
};
